import {ICON_TYPES} from '../constants';

export const FacebookLogoIcon = (): JSX.Element => {
  return (
    <svg
      width='33'
      height='32'
      viewBox='0 0 33 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path
          d='M13.694 31.84C6.09399 30.48 0.333984 23.92 0.333984 16C0.333984 7.2 7.53398 0 16.334 0C25.134 0 32.334 7.2 32.334 16C32.334 23.92 26.574 30.48 18.974 31.84L18.094 31.12H14.574L13.694 31.84Z'
          fill='url(#paint0_linear_2865_90964)'
        />
        <path
          d='M22.5734 20.48L23.2934 16H19.0534V12.88C19.0534 11.6 19.5334 10.64 21.4534 10.64H23.5334V6.55999C22.4134 6.39999 21.1334 6.23999 20.0134 6.23999C16.3334 6.23999 13.7734 8.47999 13.7734 12.48V16H9.77344V20.48H13.7734V31.76C14.6534 31.92 15.5334 32 16.4134 32C17.2934 32 18.1734 31.92 19.0534 31.76V20.48H22.5734Z'
          fill='white'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_2865_90964'
          x1='16.3348'
          y1='30.8871'
          x2='16.3348'
          y2='-0.00589422'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#0062E0' />
          <stop offset='1' stopColor='#19AFFF' />
        </linearGradient>
        <clipPath id='clip0_2865_90964'>
          <rect
            width='32'
            height='32'
            fill='white'
            transform='translate(0.333984)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

FacebookLogoIcon.iconType = ICON_TYPES.FACEBOOK_LOGO;
